function o(e) {
  return new Promise((n, t) => {
    e.oncomplete = e.onsuccess = () => n(e.result), e.onabort = e.onerror = () => t(e.error);
  });
}
function l(e, n) {
  const t = indexedDB.open(e);
  t.onupgradeneeded = () => t.result.createObjectStore(n);
  const r = o(t);
  return (i, a) => r.then((d) => a(d.transaction(n, i).objectStore(n)));
}
let c;
function u() {
  return c || (c = l("keyval-store", "keyval")), c;
}
function f(e, n = u()) {
  return n("readonly", (t) => o(t.get(e)));
}
function p(e, n, t = u()) {
  return t("readwrite", (r) => (r.put(n, e), o(r.transaction)));
}
function s(e, n = u()) {
  return n("readwrite", (t) => (t.delete(e), o(t.transaction)));
}
export {
  l as createStore,
  s as del,
  f as get,
  o as promisifyRequest,
  p as set
};
